import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { FiltersService, TransportListViewMode } from '../../../../store/models/filter.model';
import { CamelCasePipe } from '../../../../common/pipes/camel-case.pipe';

@Component({
    selector: 'ui-monitoring-list-view-toolbar',
    imports: [CommonModule, ReactiveFormsModule, MatButtonToggleModule, MatFormFieldModule, TranslateModule, CamelCasePipe],
    templateUrl: './monitoring-list-view-toolbar.component.html',
    styleUrls: ['./monitoring-list-view-toolbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MonitoringListViewToolbarComponent {
  @Input() listFiltersService: FiltersService;
  @Input() listViewModeOptions?: TransportListViewMode;
}
